import { CampaignColumn, ColumnHeaders } from '@src/application/modules/shared/type';
import { QATest } from '../shared/tag/types';
import TagCampaignSummary from '@src/application/modules/tag/Campaigns/Campaign/CampaignSummary/CampaignSummary';
import { CampaignDetails as TagCampaignDetails } from '@src/application/modules/tag/Campaigns/Campaign/CampaignDetails/CampaignDetails';
import { Desktop } from '@src/application/modules/shared/components/MediaQuery/MediaQuery';

type TagCampaignProps = {
  test: QATest;
  handleExpand: () => void;
  expand: boolean;
  header: ColumnHeaders<CampaignColumn>;
};

export function TagCampaignWrapper({ test, header, handleExpand, expand }: TagCampaignProps) {
  return (
    <>
      <TagCampaignSummary test={test} expand={handleExpand} expanded={expand} header={header} />
      <Desktop>
        <TagCampaignDetails test={test} expanded={expand} />
      </Desktop>
    </>
  );
}
